import { Document, Font, Image, Page, Text } from '@react-pdf/renderer';

import RobotoLightFont from '@/assets/fonts/Roboto-Light.ttf';
import RobotoRegularFont from '@/assets/fonts/Roboto-Regular.ttf';
import { ITagOption } from '@/features/fermentation/utils/tags-label-mapper';

import { PDFBatchFormatType } from './format-batches';
import { getFermentationTags } from './get-fermentation-tags';
import { SingleMeasurement } from './single-measurment';

export const getFermentationPdfDocument = async ({
  data,
  tagList,
  fermentationGraph,
}: {
  tagList: ITagOption[];
  fermentationGraph: string;
  data: PDFBatchFormatType[];
}) => {
  Font.register({
    family: 'Roboto',
    fonts: [{ src: RobotoLightFont, fontWeight: 200 }, { src: RobotoRegularFont }],
  });

  const tags = getFermentationTags(tagList);

  const document = (
    <Document>
      <Page size="A4" style={{ fontFamily: 'Roboto', padding: 30, fontSize: 12 }}>
        <Text style={{ fontWeight: 'bold', fontSize: 20, marginBottom: 10 }}>
          Fermentation Data
        </Text>
        <Image src={fermentationGraph} />
        {tags}
      </Page>
      {data.map(({ images, histogram, table }) => (
        <SingleMeasurement
          key={images[0].batchId}
          table={table}
          images={images}
          histogram={histogram}
        />
      ))}
    </Document>
  );

  return document;
};
